module.exports = __webpack_public_path__ + "img/AMSA.907578f1.png";